import { Field } from "react-final-form";
import { Dropzone } from "@/shared/components/Dropzone";
import {
  UploadAvatarMutation,
  UploadBannerMutation,
  UploadImageMutation,
  AvatarQuery,
  BannerQuery,
  ImageQuery,
} from "@/shared/graphql";

export type ImageFieldType = "avatar" | "banner" | "image";

interface ImageFieldProps {
  name: string;
  imageType: ImageFieldType;
  label: string;
  helperText?: string;
  required?: boolean;
  width?: number | string;
  height?: number | string;
  square?: boolean;
  maxSize?: number;
}

const IMAGE_CONFIG = {
  avatar: {
    mutation: UploadAvatarMutation,
    query: AvatarQuery,
    square: true,
  },
  banner: {
    mutation: UploadBannerMutation,
    query: BannerQuery,
    square: false,
  },
  image: {
    mutation: UploadImageMutation,
    query: ImageQuery,
    square: false,
  },
};

export function ImageField({
  name,
  imageType,
  label,
  helperText,
  required = false,
  maxSize,
  ...restProps
}: ImageFieldProps) {
  const config = IMAGE_CONFIG[imageType];

  return (
    <Field
      name={name}
      render={({ input: { onChange, value }, ...rest }) => (
        <Dropzone
          onChange={onChange}
          value={value}
          query={config.query}
          mutation={config.mutation}
          label={label}
          helperText={helperText}
          required={required}
          width="100%"
          square
          accept="image/*"
          maxSize={maxSize}
          deleteButtonPosition="overlay"
          {...rest}
          {...restProps}
        />
      )}
    />
  );
}
